// Prestige Elements discovery quizzes. Scored client-side so logged-out visitors
// can take them; results feed the Wellness Profile when saved.

export const CLAIR_QUIZ = {
  key: 'clair',
  title: 'Discover Your Clair',
  tagline: 'Reveal your intuitive language — how your inner senses speak to you.',
  labels: {
    clairvoyance: 'Clairvoyance · Clear Seeing',
    clairaudience: 'Clairaudience · Clear Hearing',
    clairsentience: 'Clairsentience · Clear Feeling',
    claircognizance: 'Claircognizance · Clear Knowing',
  },
  blurbs: {
    clairvoyance: 'You receive intuition through images, colors, symbols and vivid inner visuals.',
    clairaudience: 'You receive intuition through sounds, words, inner voice and meaningful phrases.',
    clairsentience: 'You feel energy and emotion in your body — a deeply empathic, sensing knowing.',
    claircognizance: 'You simply know things — sudden clarity and downloads without knowing how.',
  },
  questions: [
    { q: 'When you recall a favorite memory, what comes first?', options: [
      { label: 'A clear picture or scene', type: 'clairvoyance' },
      { label: 'Sounds, music or voices', type: 'clairaudience' },
      { label: 'The feeling in my body', type: 'clairsentience' },
      { label: 'Just knowing it mattered', type: 'claircognizance' } ] },
    { q: 'You walk into a room full of people. You immediately…', options: [
      { label: 'Notice the visual mood and colors', type: 'clairvoyance' },
      { label: 'Tune into the tone of conversations', type: 'clairaudience' },
      { label: 'Absorb the emotional energy', type: 'clairsentience' },
      { label: 'Sense who to trust', type: 'claircognizance' } ] },
    { q: 'How do your best ideas usually arrive?', options: [
      { label: 'As mental images or daydreams', type: 'clairvoyance' },
      { label: 'As a phrase I "hear" in my mind', type: 'clairaudience' },
      { label: 'As a gut or heart feeling', type: 'clairsentience' },
      { label: 'As instant certainty', type: 'claircognizance' } ] },
    { q: 'When meditating, what is most vivid?', options: [
      { label: 'Colors, symbols, light', type: 'clairvoyance' },
      { label: 'Ringing, tones or words', type: 'clairaudience' },
      { label: 'Waves of sensation', type: 'clairsentience' },
      { label: 'Quiet inner knowing', type: 'claircognizance' } ] },
    { q: 'A friend is upset but says they are fine. You…', options: [
      { label: 'See it on their face instantly', type: 'clairvoyance' },
      { label: 'Hear it in their voice', type: 'clairaudience' },
      { label: 'Feel their heaviness yourself', type: 'clairsentience' },
      { label: 'Just know they are not fine', type: 'claircognizance' } ] },
    { q: 'Which would you most trust?', options: [
      { label: 'A vivid dream or vision', type: 'clairvoyance' },
      { label: 'A song that keeps repeating', type: 'clairaudience' },
      { label: 'A strong body sensation', type: 'clairsentience' },
      { label: 'A sudden, calm certainty', type: 'claircognizance' } ] },
  ],
};

export const WITCH_QUIZ = {
  key: 'witch',
  title: 'What Type of Witch Are You?',
  tagline: 'Explore the practice archetype that resonates with your energy.',
  labels: {
    green: 'Green Witch', crystal: 'Crystal Witch', lunar: 'Lunar Witch',
    cosmic: 'Cosmic Witch', kitchen: 'Kitchen Witch', sea: 'Sea Witch', hearth: 'Hearth Witch',
  },
  blurbs: {
    green: 'Rooted in plants, herbs and the living earth — your magic grows.',
    crystal: 'Drawn to stones and energy — you work with crystalline vibration.',
    lunar: 'Guided by the moon, cycles and dreams — you flow with the tides within.',
    cosmic: 'Aligned with stars and astrology — you read the language of the sky.',
    kitchen: 'Practical and nourishing — you infuse intention into everyday craft.',
    sea: 'Fluid and cleansing — water, salt and release are your allies.',
    hearth: 'Home, comfort and care — you tend warmth and sacred everyday ritual.',
  },
  questions: [
    { q: 'Your ideal sacred space includes…', options: [
      { label: 'Plants and dried herbs', type: 'green' },
      { label: 'A crystal collection', type: 'crystal' },
      { label: 'Moon phases and a journal', type: 'lunar' },
      { label: 'Star charts', type: 'cosmic' } ] },
    { q: 'What draws you most?', options: [
      { label: 'Cooking with intention', type: 'kitchen' },
      { label: 'Baths and the ocean', type: 'sea' },
      { label: 'A cozy candlelit home', type: 'hearth' },
      { label: 'Gardening', type: 'green' } ] },
    { q: 'Your intuition peaks when…', options: [
      { label: 'Under a full moon', type: 'lunar' },
      { label: 'Holding a crystal', type: 'crystal' },
      { label: 'Reading my horoscope', type: 'cosmic' },
      { label: 'Near water', type: 'sea' } ] },
    { q: 'Pick a ritual tool:', options: [
      { label: 'Fresh herbs', type: 'green' },
      { label: 'A cleansing salt bath', type: 'sea' },
      { label: 'A simmering pot on the stove', type: 'kitchen' },
      { label: 'A crystal grid', type: 'crystal' } ] },
    { q: 'How do you recharge?', options: [
      { label: 'Making my home warm and safe', type: 'hearth' },
      { label: 'Tracking the moon and resting', type: 'lunar' },
      { label: 'Studying the cosmos', type: 'cosmic' },
      { label: 'Tending my plants', type: 'green' } ] },
    { q: 'Your magic is most about…', options: [
      { label: 'Nourishment and care', type: 'kitchen' },
      { label: 'Emotional cleansing', type: 'sea' },
      { label: 'Comfort and protection', type: 'hearth' },
      { label: 'Energy and vibration', type: 'crystal' } ] },
    { q: 'A perfect evening is…', options: [
      { label: 'Moonlit journaling', type: 'lunar' },
      { label: 'Stargazing', type: 'cosmic' },
      { label: 'Baking and tea', type: 'kitchen' },
      { label: 'A warm bath ritual', type: 'sea' } ] },
  ],
};

export const CHAKRA_QUIZ = {
  key: 'chakra',
  title: 'Which Chakra Needs Your Attention?',
  tagline: 'A gentle reflection on where your energy may be asking for care.',
  reflection: 'This is an invitation for gentle reflection — not a diagnosis. Chakras named here are simply areas you might explore, never something "blocked" or in need of fixing.',
  labels: {
    root: 'Root · Grounding & Safety', sacral: 'Sacral · Creativity & Flow',
    solar: 'Solar Plexus · Confidence & Will', heart: 'Heart · Love & Compassion',
    throat: 'Throat · Expression & Truth', thirdeye: 'Third Eye · Intuition & Insight',
    crown: 'Crown · Connection & Spirit',
  },
  blurbs: {
    root: 'You may be craving stability, safety and grounding right now — gentle rituals that help you feel held.',
    sacral: 'Creativity, pleasure and emotional flow may be calling for your attention and play.',
    solar: 'Confidence, personal will and a sense of your own power may be areas to nurture.',
    heart: 'Compassion, connection and self-love may be where your energy wants to open.',
    throat: 'Authentic expression and speaking your truth may be inviting exploration.',
    thirdeye: 'Intuition, insight and inner vision may be especially alive for you now.',
    crown: 'Connection to something larger — meaning, spirit, stillness — may be calling.',
  },
  questions: [
    { q: 'Lately you most long for…', options: [
      { label: 'Stability and security', type: 'root' },
      { label: 'Joy and creative play', type: 'sacral' },
      { label: 'Confidence in myself', type: 'solar' },
      { label: 'Deeper connection', type: 'heart' } ] },
    { q: 'What feels hardest right now?', options: [
      { label: 'Speaking my truth', type: 'throat' },
      { label: 'Trusting my intuition', type: 'thirdeye' },
      { label: 'Feeling grounded', type: 'root' },
      { label: 'Quieting my mind', type: 'crown' } ] },
    { q: 'You feel most alive when…', options: [
      { label: 'Creating or making', type: 'sacral' },
      { label: 'Helping and loving others', type: 'heart' },
      { label: 'Expressing myself', type: 'throat' },
      { label: 'In meditation or prayer', type: 'crown' } ] },
    { q: 'A recurring theme for you is…', options: [
      { label: 'Wanting to feel safe', type: 'root' },
      { label: 'Seeking purpose and power', type: 'solar' },
      { label: 'Trusting inner knowing', type: 'thirdeye' },
      { label: 'Opening my heart', type: 'heart' } ] },
    { q: 'Which practice draws you most?', options: [
      { label: 'Grounding & earthing', type: 'root' },
      { label: 'Journaling & voice', type: 'throat' },
      { label: 'Dream & vision work', type: 'thirdeye' },
      { label: 'Creative movement', type: 'sacral' } ] },
    { q: 'Right now you want to feel more…', options: [
      { label: 'Empowered', type: 'solar' },
      { label: 'Connected to spirit', type: 'crown' },
      { label: 'Loving and open', type: 'heart' },
      { label: 'Rooted and calm', type: 'root' } ] },
  ],
};

export const ELEMENT_QUIZ = {
  key: 'element',
  title: 'Your Dominant Element',
  tagline: 'Discover the elemental energy that moves through you.',
  reflection: 'A playful reflection of your energy — many people carry a blend of elements, and yours can shift over time.',
  labels: {
    earth: 'Earth · Grounded & Steady', air: 'Air · Curious & Free',
    fire: 'Fire · Passionate & Driven', water: 'Water · Feeling & Flow',
    spirit: 'Spirit · Connected & Transcendent',
  },
  blurbs: {
    earth: 'Steady, nurturing and grounded — you find magic in the tangible and the rooted.',
    air: 'Curious, communicative and free — you move with ideas, words and inspiration.',
    fire: 'Passionate, bold and transformative — you create through energy and will.',
    water: 'Intuitive, emotional and flowing — you feel deeply and move with the tides.',
    spirit: 'Connected and transcendent — you sense the unseen threads between all things.',
  },
  questions: [
    { q: 'You recharge best by…', options: [
      { label: 'Being in nature', type: 'earth' },
      { label: 'Learning something new', type: 'air' },
      { label: 'Moving and doing', type: 'fire' },
      { label: 'Resting near water', type: 'water' } ] },
    { q: 'Friends describe you as…', options: [
      { label: 'Dependable', type: 'earth' },
      { label: 'Free-spirited', type: 'air' },
      { label: 'Passionate', type: 'fire' },
      { label: 'Deeply intuitive', type: 'spirit' } ] },
    { q: 'Your ideal ritual involves…', options: [
      { label: 'Herbs and soil', type: 'earth' },
      { label: 'Incense and breath', type: 'air' },
      { label: 'Candles and flame', type: 'fire' },
      { label: 'A cleansing bath', type: 'water' } ] },
    { q: 'You make decisions with your…', options: [
      { label: 'Practical sense', type: 'earth' },
      { label: 'Mind and logic', type: 'air' },
      { label: 'Gut and drive', type: 'fire' },
      { label: 'Heart and feeling', type: 'water' } ] },
    { q: 'You feel most connected during…', options: [
      { label: 'Quiet stillness / prayer', type: 'spirit' },
      { label: 'A spark of inspiration', type: 'air' },
      { label: 'Emotional release', type: 'water' },
      { label: 'Time outdoors', type: 'earth' } ] },
    { q: 'Your energy is most like…', options: [
      { label: 'A steady mountain', type: 'earth' },
      { label: 'A shifting breeze', type: 'air' },
      { label: 'A blazing flame', type: 'fire' },
      { label: 'A flowing river', type: 'water' } ] },
  ],
};

export const QUIZZES = { clair: CLAIR_QUIZ, witch: WITCH_QUIZ, chakra: CHAKRA_QUIZ, element: ELEMENT_QUIZ };

export function scoreQuiz(quiz, answers) {
  const tally = {};
  answers.forEach((t) => { if (t) tally[t] = (tally[t] || 0) + 1; });
  const total = answers.filter(Boolean).length || 1;
  const sorted = Object.entries(tally).sort((a, b) => b[1] - a[1]);
  const breakdown = {};
  sorted.forEach(([k, v]) => { breakdown[k] = Math.round((v / total) * 100); });
  const primary = sorted[0] ? sorted[0][0] : null;
  const secondary = sorted[1] ? sorted[1][0] : null;
  return {
    primary, secondary,
    primary_label: primary ? quiz.labels[primary] : null,
    secondary_label: secondary ? quiz.labels[secondary] : null,
    breakdown,
  };
}
